export const vs2ngaVersionListConstants = {
  VS2NGAVERSION_LIST_LOADING: "VS2NGAVERSION_LIST_LOADING",
  VS2NGAVERSION_LIST_SUCCESS: "VS2NGAVERSION_LIST_SUCCESS",
  VS2NGAVERSION_LIST_FAILURE: "VS2NGAVERSION_LIST_FAILURE",
};

export const vs2ngaVersionUploadConstants = {
  VS2NGAVERSION_UPLOAD_LOADING: "VS2NGAVERSION_UPLOAD_LOADING",
  VS2NGAVERSION_UPLOAD_SUCCESS: "VS2NGAVERSION_UPLOAD_SUCCESS",
  VS2NGAVERSION_UPLOAD_FAILURE: "VS2NGAVERSION_UPLOAD_FAILURE",
};

export const vs2ngaVersionConstants = {
  VS2NGAVERSION_LOADING: "VS2NGAVERSION_LOADING",
  VS2NGAVERSION_SUCCESS: "VS2NGAVERSION_SUCCESS",
  VS2NGAVERSION_FAILURE: "VS2NGAVERSION_FAILURE",
};

export const vs2ngaVersionDeleteConstants = {
  VS2NGAVERSION_DELETE_LOADING: "VS2NGAVERSION_DELETE_LOADING",
  VS2NGAVERSION_DELETE_SUCCESS: "VS2NGAVERSION_DELETE_SUCCESS",
  VS2NGAVERSION_DELETE_FAILURE: "VS2NGAVERSION_DELETE_FAILURE",
};
